import React from "react";
import EvaluateAndTask from "./components/EvaluateAndTask";
import EvaluateMoveOut from "./components/EvaluateMoveOut";
import MakeReady from "./components/MakeReady";
import PropertyListing from "./components/PropertyListing";
import TenantOwnerFollowUp from "./components/TenantOwnerFollowUp";
import ConfirmNotice from "./components/ConfirmNotice";
import SingleMoveOut from "./components/SingleMoveOut";
import BreakingLease from "./components/BreakingLease";
import MoveOutDirection from "./components/MoveOutDirection";
import OwnerReqNonRenewal from "./components/OwnerReqNonRenewal";
import MoveOutDay from "./components/MoveOutDay";
import KeysIn from "./components/KeysIn";
import KeysMissing from "./components/KeysMissing";
import Inspections from "./components/Inspections";
import PropertyInspection from "./components/PropertyInspection";
import SupportStaffInspection from "./components/SupportStaffInspection";
import EndingProcess from "./components/EndingProcess";
import EndingManagment from "./components/EndingManagment";
import CancelMoveOut from "./components/CancelMoveOut";
import FAQLinks from "./components/FAQLinks";

const MoveOutContent = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <EvaluateAndTask
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <EvaluateMoveOut
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <MakeReady
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <PropertyListing
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <TenantOwnerFollowUp
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <ConfirmNotice
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <SingleMoveOut
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <BreakingLease
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <MoveOutDirection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <OwnerReqNonRenewal
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 11 && (
        <MoveOutDay
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <KeysIn itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 13 && (
        <KeysMissing
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 14 && (
        <Inspections
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 15 && (
        <PropertyInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 16 && (
        <SupportStaffInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 17 && (
        <EndingProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 18 && (
        <EndingManagment
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 19 && (
        <CancelMoveOut
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 20 && (
        <FAQLinks itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
    </div>
  );
};

export default MoveOutContent;
